import React from "react";
import "./Preheader.css";

function Preheader() {
  return (
    <div
      className={"preheader-wrapper"}
      style={{ position: "relative", zIndex: 1 }}
    >
      <div className={"preheader-text"}>
        Τα δεδομένα που χρησιμοποιήθηκαν για τη δόμηση της υπηρεσίας συλλέχθηκαν
        και επεξεργάστηκαν στο πλαίσιο της ερευνητικής υποδομής ENIRISST.
      </div>
      <div>
        Πηγές:{" "}
        <span className={"text_format_bold"}>
          ΕΛΣΤΑΤ, Eurostat, Openstreetmap
        </span>
      </div>
    </div>
  );
}

export default Preheader;
